import { Reducer } from "redux";

import SidebarState from "./SidebarState";
import { SidebarActionTypes, SidebarAction } from "./SidebarActions";

const initialState: SidebarState = {
  sidebarShow: true,
  menuItems: []
};

const SidebarReducer: Reducer<SidebarState, SidebarAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case SidebarActionTypes.SET_SIDEBAR_SHOW:
      return { ...state, sidebarShow: action.data };
    case SidebarActionTypes.SET_SIDEBAR_MENU_ITEMS:
      return { ...state, menuItems: [...action.data] };
    default: {
      return state;
    }
  }
};

export default SidebarReducer;